exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member_box[data-v-b73fca7c]{padding:20px}", ""]);

// exports
